module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Regular.e8326c5.woff";